import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Typography,
  styled,
  Grid2,
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";

// Custom styled Radio
const StyledRadio = styled(Radio)(() => ({
    padding: 0,
    marginRight: "8px", // spacing between radio circle and label
}));

// Custom styled FormControlLabel
const StyledFormControlLabel = styled(FormControlLabel)((theme) => ({
    margin: 0,
    "& .MuiFormControlLabel-label": {
      fontFamily: theme.primaryFontV2,
      color: "#15191E",
      fontSize: "12px",
      lineHeight: "16px",
    },
  }));

const ChartSeries = ({ selectedEntities, onUpdateEntities }) => {

  const [groupedEntities, setGroupedEntities] = useState([]);

  const handleYAxisChangeForGroup = useCallback((groupedEntity, newYAxis) => {
    const updatedSelectedEntities = selectedEntities.map((entity) => {
      if (entity.metric === groupedEntity.metric && entity.type === groupedEntity.type) {
        return {
          ...entity,
          yaxis: newYAxis,
        };
      }
      return entity;
    });

    const updatedGroupedEntities = groupedEntities.map((entity) => {
      if (entity.metric === groupedEntity.metric && entity.type === groupedEntity.type) {
        return {
          ...entity,
          yaxis: newYAxis,
        };
      }
      return entity;
    });

    setGroupedEntities(updatedGroupedEntities);

    onUpdateEntities(updatedSelectedEntities);
  }, [selectedEntities, groupedEntities]);

  useEffect(() => {
    const grouped = Object.values(
      selectedEntities.reduce((acc, item) => {
        const key = `${item.metric}_${item.type}`;
        if (!acc[key]) {
          acc[key] = {
            metric: item.metric,
            label: item.unit ? `${item.label} (${item.unit})` : item.label,
            type: item.type,
            yaxis: item.yaxis,
            count: 0
          };
        }
        acc[key].count++;
        return acc;
      }, {})
    );

    setGroupedEntities(grouped);

  }, [selectedEntities])

  return (
    <Box sx={{ maxHeight: '525px', overflowY: 'auto' }}>
        {groupedEntities.map((entity, index) => {
        return (
          <Grid2
            key={`${entity.type}_${entity.label}`}
            container
            justifyContent={'space-between'}
            alignItems={'center'}
            gap={1}
            sx={{
                py: 1.5,
                borderTop: index !== 0 ? '1px solid #E6E6E6' : 'none',
                wordBreak: 'break-all',
                flexWrap: 'nowrap'
            }}
            >
            <Grid2 container flexDirection={'column'} gap={0.5} sx={{wordBreak: 'break-all'}}>
                <Typography variant="fw500s12c000" sx={{lineHeight: '16px', wordBreak: 'break-all', textTransform: 'capitalize'}}>{entity.label}</Typography>
                <Typography variant="fw400s12c686868" sx={{lineHeight: '16px', textTransform: 'capitalize'}}>
                  {entity.count}&nbsp;{entity.count > 1 ? `${entity.type}s` : entity.type}
                </Typography>
            </Grid2>
            <Box sx={{minWidth: '50px'}}>
              <FormControl>
                <RadioGroup
                    aria-labelledby={`y-axis-${entity.type}-${entity.label}`}
                    value={entity.yaxis || "Y1"}
                    name={`y-axis-${entity.type}-${entity.label}`}
                    sx={{gap: 1}}
                    onChange={(e) => {
                      const newYAxis = e.target.value;
                      handleYAxisChangeForGroup(entity, newYAxis);
                    }}
                >
                    <StyledFormControlLabel value="Y1" control={<StyledRadio />} label="Y1" />
                    <StyledFormControlLabel value="Y2" control={<StyledRadio />} label="Y2" />
                </RadioGroup>
              </FormControl>
            </Box>
          </Grid2>
        )
        })}
    </Box>
  );
};

export default ChartSeries;
